import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  width: 100%;
  min-width: 100%;
`;

const FullScreenModal = ({ name, open, setVisible, children }) => {
  return (
    <StyledModal
      centered
      title={name}
      open={open}
      onCancel={() => setVisible(false)}
      footer={null}
      wrapClassName="retention-modal"
    >
      {children}
    </StyledModal>
  );
};

export default FullScreenModal;
